import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { currencyUtils } from '~/utils/currency.utils';
import { connectControllerToTextField, rhfValidateToBottomSheet } from '~/utils/react-hook-form.utils';
export default function PriceTextField(param) {
    let { onChange = ()=>{}, testId, disabled } = param;
    const { control, watch } = useFormContext();
    const { t: priceTexts } = useLocaleKeys('billing.price');
    const [pricing, unitName] = watch([
        'pricing',
        'unitName'
    ]);
    const getLabel = ()=>{
        if (pricing === 'fixed') {
            return priceTexts.label.fixed();
        }
        if (pricing === 'range') {
            return priceTexts.label.maxPrice();
        }
        return pricing === 'hour' ? priceTexts.label.perHour() : priceTexts.label.perUnit();
    };
    const getSuffix = ()=>{
        if (pricing === 'unit') {
            if (!unitName) return undefined;
            const shouldEllipsize = unitName.length > 20;
            return /*#__PURE__*/ _jsx("span", {
                style: shouldEllipsize ? {
                    whiteSpace: 'nowrap',
                    maxWidth: '20ch',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                } : {
                    whiteSpace: 'nowrap'
                },
                children: "/".concat(unitName)
            });
        }
        if (pricing === 'hour') return priceTexts.suffix.perHour();
        return undefined;
    };
    const validate = (val)=>val && +val >= 0 || priceTexts.validation.mustBeNonNegative();
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "price",
        rules: {
            validate
        },
        render: (renderProps)=>{
            const connectedProps = connectControllerToTextField(renderProps);
            const price = renderProps.field.value;
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                mobile: {
                    renderAsCard: true,
                    displayValue: price ? currencyUtils.formatDollarAmount(price) : ''
                },
                bi: {
                    name: 'price'
                },
                disabled: disabled,
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                label: getLabel(),
                prefix: "$",
                suffix: getSuffix(),
                testId: testId,
                validateInBottomSheet: rhfValidateToBottomSheet(validate)
            }, connectedProps), {
                onChange: (e)=>{
                    connectedProps.onChange(e);
                    onChange(e.target.value);
                }
            }));
        }
    });
}
